import { getWorkTypeList } from "./Helpers/GetWorkTypes";

export const getFormattedDate = (dateInput) => {
  if (!dateInput) return "Invalid Date"; // Handle empty input

  // Trim and convert to a Date object
  const date = new Date(String(dateInput).trim());

  if (isNaN(date.getTime())) {
    return "Invalid Date"; // Handle invalid dates
  }

  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return "N/A"; // Handle null or undefined values

  // Remove all non-numeric characters
  const cleaned = phone.toString().replace(/\D/g, "");

  // Ensure the number has at least 10 digits
  if (cleaned.length < 10) return "Invalid Number";

  // Extract parts (Area Code - Prefix - Line Number)
  const formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(
    3,
    6,
  )}-${cleaned.slice(6, 10)}`;

  return formatted;
};

export const getLabelsFromWorktypes = async (worktypes) => {
  console.log("Worktypes:", worktypes);
  // return "ok";
  const worktypeArray = Array.isArray(worktypes)
    ? worktypes // Already an array
    : worktypes?.split(",").map((id) => id.trim()) || [];

  if (worktypeArray.length === 0) return "Unknown";

  const workTypeList = await getWorkTypeList();
  return worktypeArray
    .map(
      (id) =>
        workTypeList.find((item) => item.value === id)?.label || "Unknown",
    )
    .join(", ");
};

export const getTimeAgo = (date) => {
  if (!date) return "";
  const postedDate = new Date(date);
  const today = new Date();
  const diffTime = Math.abs(today - postedDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 30) return `${diffDays} days ago`;

  const diffMonths = Math.floor(diffDays / 30);
  return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
};

export const getSelectedStateLatLong = (selectedState) => {
  console.log("calling helper");
  const stateCoordinates = {
    AL: { lat: 32.3182, lng: -86.9023, name: "Alabama" },
    AK: { lat: 63.5888, lng: -154.4931, name: "Alaska" },
    AZ: { lat: 34.0489, lng: -111.0937, name: "Arizona" },
    AR: { lat: 35.201, lng: -91.8318, name: "Arkansas" },
    CA: { lat: 36.7783, lng: -119.4179, name: "California" },
    CO: { lat: 39.5501, lng: -105.7821, name: "Colorado" },
    CT: { lat: 41.6032, lng: -73.0877, name: "Connecticut" },
    DE: { lat: 38.9108, lng: -75.5277, name: "Delaware" },
    FL: { lat: 27.6648, lng: -81.5158, name: "Florida" },
    GA: { lat: 32.1656, lng: -82.9001, name: "Georgia" },
    HI: { lat: 19.8968, lng: -155.5828, name: "Hawaii" },
    ID: { lat: 44.0682, lng: -114.742, name: "Idaho" },
    IL: { lat: 40.6331, lng: -89.3985, name: "Illinois" },
    IN: { lat: 40.2672, lng: -86.1349, name: "Indiana" },
    IA: { lat: 41.878, lng: -93.0977, name: "Iowa" },
    KS: { lat: 38.5266, lng: -96.7265, name: "Kansas" },
    KY: { lat: 37.8393, lng: -84.27, name: "Kentucky" },
    LA: { lat: 31.1695, lng: -91.8678, name: "Louisiana" },
    ME: { lat: 45.2538, lng: -69.4455, name: "Maine" },
    MD: { lat: 39.0458, lng: -76.6413, name: "Maryland" },
    MA: { lat: 42.4072, lng: -71.3824, name: "Massachusetts" },
    MI: { lat: 44.3148, lng: -85.6024, name: "Michigan" },
    MN: { lat: 46.7296, lng: -94.6859, name: "Minnesota" },
    MS: { lat: 32.3547, lng: -89.3985, name: "Mississippi" },
    MO: { lat: 37.9643, lng: -91.8318, name: "Missouri" },
    MT: { lat: 46.8797, lng: -110.3626, name: "Montana" },
    NE: { lat: 41.1254, lng: -98.2681, name: "Nebraska" },
    NV: { lat: 38.8026, lng: -116.4194, name: "Nevada" },
    NH: { lat: 43.1939, lng: -71.5724, name: "New Hampshire" },
    NJ: { lat: 40.0583, lng: -74.4057, name: "New Jersey" },
    NM: { lat: 34.5199, lng: -105.8701, name: "New Mexico" },
    NY: { lat: 40.7128, lng: -74.006, name: "New York" },
    NC: { lat: 35.7596, lng: -79.0193, name: "North Carolina" },
    ND: { lat: 47.5502, lng: -101.002, name: "North Dakota" },
    OH: { lat: 40.4173, lng: -82.9071, name: "Ohio" },
    OK: { lat: 35.0078, lng: -97.0929, name: "Oklahoma" },
    OR: { lat: 43.8041, lng: -120.5542, name: "Oregon" },
    PA: { lat: 41.2033, lng: -77.1945, name: "Pennsylvania" },
    RI: { lat: 41.5801, lng: -71.4774, name: "Rhode Island" },
    SC: { lat: 33.8361, lng: -81.1637, name: "South Carolina" },
    SD: { lat: 44.2998, lng: -99.4388, name: "South Dakota" },
    TN: { lat: 35.5175, lng: -86.5804, name: "Tennessee" },
    TX: { lat: 31.9686, lng: -99.9018, name: "Texas" },
    UT: { lat: 39.321, lng: -111.0937, name: "Utah" },
    VT: { lat: 44.5588, lng: -72.5778, name: "Vermont" },
    VA: { lat: 37.4316, lng: -78.6569, name: "Virginia" },
    WA: { lat: 47.7511, lng: -120.7401, name: "Washington" },
    WV: { lat: 38.5976, lng: -80.4549, name: "West Virginia" },
    WI: { lat: 43.7844, lng: -88.7879, name: "Wisconsin" },
    WY: { lat: 43.076, lng: -107.2903, name: "Wyoming" },
  };

  if (!selectedState || !selectedState.label)
    return { lat: 37.0902, lng: -95.7129 };

  const label = selectedState.label.trim();

  // 1. Try to find by Abbreviation (Key)
  if (stateCoordinates[label]) {
    return {
      lat: stateCoordinates[label].lat,
      lng: stateCoordinates[label].lng,
    };
  }

  // 2. Try to find by Full Name (Value)
  const foundState = Object.values(stateCoordinates).find(
    (s) => s.name.toLowerCase() === label.toLowerCase(),
  );

  return foundState
    ? { lat: foundState.lat, lng: foundState.lng }
    : { lat: 37.0902, lng: -95.7129 }; // Fallback to US Center
};
